import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TPostNetPayDuplicateBankAccountSuppressionRequest,
  TPostNetPayDuplicateBankAccountSuppressionResponse,
} from "./postNetPayDuplicateBankAccountSuppression.schema";

const URL = "/api/net-pay-duplicate-bank-account-suppressions";

export const postNetPayDuplicateBankAccountSuppression = (
  axios: IAxiosInstance
) => {
  return async (
    requestBody: TPostNetPayDuplicateBankAccountSuppressionRequest
  ) => {
    const response = await axios.noRetry.post<
      IApiResponse<TPostNetPayDuplicateBankAccountSuppressionResponse>
    >(URL, requestBody);
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
